import React from "react";
import ComponentMenu from "../../components/layout/ComponentMenu";
import { Container } from "react-bootstrap";
import ComponentFocusGouvernance from "../../components/admin/alaune/ComponentFocusGouvernance";
import ComponentFocusRencontre from "../../components/admin/alaune/ComponentFocusRencontre";
import ComponentFocusInspiration from "../../components/admin/alaune/ComponentFocusInspiration";
import ComponentTitle from "../../components/layout/ComponentTitle";
import { useTranslation } from "react-i18next";

const PageAdminAlaUne = () => {
  const { t } = useTranslation();
  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminAlaUne.titre")} />
        <ComponentFocusInspiration />
        <ComponentFocusRencontre />
        <ComponentFocusGouvernance />
      </Container>
    </>
  );
};

export default PageAdminAlaUne;
